import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Load Mapbox CSS asynchronously to prevent blocking (match installed mapbox-gl version)
const mapboxCSS = document.createElement('link');
mapboxCSS.rel = 'stylesheet';
mapboxCSS.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
mapboxCSS.media = 'print';
mapboxCSS.onload = function() { this.media = 'all'; };
document.head.appendChild(mapboxCSS);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
